var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/BimNodeIcon/BimNodeIcon.tsx";
import React from 'react';
import { Category as CategoryIcon, Home as HomeIcon, Family as FamilyIcon, Cubes as CubesIcon, Cube as CubeIcon, CubeWithTarget } from '@gmini/ui-kit';
import { assertNever } from '@gmini/utils';
import { CubeWithTargetWrapper } from "../../DependencyTree/nodes/AssemblyClassifierNodeContent.styled";
import { jsx as _jsx } from "react/jsx-runtime";
export var BimNodeIcon = /*#__PURE__*/React.memo(function (_ref) {
  var type = _ref.type,
      color = _ref.color,
      opacity = _ref.opacity;

  switch (type) {
    case 'ForgeModel':
    case 'GstationModel':
    case 'BimModelNode':
      return /*#__PURE__*/_jsx(HomeIcon, {
        color: color,
        opacity: opacity
      });

    case 'AssemblyModel':
      return /*#__PURE__*/_jsx(CubeWithTargetWrapper, {
        children: /*#__PURE__*/_jsx(CubeWithTarget, {
          color: color,
          opacity: opacity
        })
      });

    case 'BimCategoryNode':
      return /*#__PURE__*/_jsx(CategoryIcon, {
        color: color,
        opacity: opacity
      });

    case 'BimFamilyNode':
      return /*#__PURE__*/_jsx(FamilyIcon, {
        color: color,
        opacity: opacity
      });

    case 'BimStandardSizeNode':
      return /*#__PURE__*/_jsx(CubesIcon, {
        color: color,
        opacity: opacity
      });

    case 'BimElementNode':
      return /*#__PURE__*/_jsx(CubeIcon, {
        color: color,
        opacity: opacity
      });

    default:
      assertNever('Unexpected type', type);
  }
});
BimNodeIcon.displayName = 'BimNodeIcon';